export default __webpack_public_path__ + "static/media/ic_empty_avatar.beb837c7.svg";